<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in">{{modalHeading}}</h4>
</div>

<div class="modal-body">
    <div *ngIf="action == 'notInterested' || action == 'release' || action == 'delete'">
        <app-set-job-match-status
            [jobMatchDetailsArrayString]="jobMatchDetailsArray"
            [statusType]="statusType"
            (saveCallback)="refresh()"
            [multipleFlag]="true"
            [sourceScreen]="'CANDIDATE_WORKFLOW'"
            [formalizeActivityPayload]="formalizeActivityPayload">
        </app-set-job-match-status>
    </div>
    <div *ngIf="action == 'move'">
        <app-move-job-match-step
            [jobMatchId]="jobMatchId"
            [candidateId]="candidateId"
            [moveType]="moveType"
            [label]="label"
            (saveCallback)="refresh()">
        </app-move-job-match-step>
    </div>
    <div *ngIf="action == 'assignRecruiter'">
        <app-assign-recruiter [jobMatchIdArrayString]="jobMatchIdArrayJson" (saveCallback)="refresh()"></app-assign-recruiter>
    </div>
    <div *ngIf="action == 'addCandidates'">
        <app-add-candidates
            [jobId]="jobId"
            [isSharedJob]="isSharedRequisition"
            [corporateId]="corporateCompanyId"
            [clientOrBuId]="clientOrBuId"
            (candidateProcessedCallback)="candidateProcessedCallback()"
            (saveCallback)="refresh()"
            [context]="'candidateJobMatchWorkflow'"
            [sourceScreen]="'CANDIDATE_WORKFLOW'"
            [formalizeActivityPayload]="formalizeActivityPayload">
        </app-add-candidates>
    </div>
    <div *ngIf="action == 'associateCandidates'">
        <app-associate-candidates
            [jobId]="jobId"
            [corporateId]="corporateCompanyId"
            [clientOrBuId]="clientOrBuId"
            [clientOrBuName]="clientOrBuName"
            [isSharedRequisition]="isSharedRequisition"
            [resumeRequiredForWorkflow]="resumeRequiredForWorkflow"
            (saveCallback)="refresh()">
        </app-associate-candidates>
    </div>
    <div *ngIf="action == 'addCandidatesFromJobBoards'">
        <app-add-candidates-from-job-boards [jobId]="jobId" (saveCallback)="refresh()"></app-add-candidates-from-job-boards>
    </div>
    <div *ngIf="action == 'compareCandidates'">
        <app-job-candidates-compare [jobId]="jobId" [candidateIds]="candidateIds"></app-job-candidates-compare>
    </div>
    <div *ngIf="action == 'jobProfile'">
        <app-job-profile [jobId]="jobId" [context]="'candidateWorkflow'" (closeModalCallback)="closeModal()"></app-job-profile>
    </div>
    <div *ngIf="action == 'sendTechAssessment' || action == 'sendValueAssessment'">
        <app-send-assessment
            [jobMatchDetailsArrayString]="jobMatchDetailsArrayJson"
            [isSharedRequisition]="isSharedRequisition"
            [corporateId]="corporateCompanyId"
            [corporateName]="corporateCompanyName"
            [buName]="clientOrBuName"
            [assessmentType]="assessmentType"
            [assessmentSendMode]="assessmentSendMode"
            (saveCallback)="refresh()"
            [sourceScreen]="'CANDIDATE_WORKFLOW'"
            [formalizeActivityPayload]="formalizeActivityPayload">
        </app-send-assessment>
    </div>
    <div *ngIf="action == 'cancelTechAssessment' || action == 'cancelValueAssessment'">
        <app-cancel-assessment
            [jobMatchIdsArrayString]="jobMatchIdArrayJson"
            [assessmentType]="assessmentType"
            (saveCallback)="refresh()"
            [sourceScreen]="'CANDIDATE_WORKFLOW'"
            [formalizeActivityPayload]="formalizeActivityPayload">
        </app-cancel-assessment>
    </div>
</div>
